<template>
    <div id="instrument-input-lot">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vx-card class="mb-base" title="Detail Instrument">
            <vs-row class="mt-4 ml-4" style="font-size:14px">
                <vs-col class="w-1/2 lg:w-1/6">
                    <label class="vs-radio--label">Instrumen</label>
                </vs-col>
                <vs-col class="w-1/2 lg:w-1/2">
                    <label class="vs-radio--label">: <b>{{model.name + ' (' +model.code +')'}}</b></label>
                </vs-col>
                <vs-col class="w-1/2 lg:w-1/6">
                    <label class="vs-radio--label">Bagian Lab</label>
                </vs-col>
                <vs-col class="w-1/2 lg:w-1/6">
                    <label class="vs-radio--label">: <b>{{model.labSection.name}}</b></label>
                </vs-col>
              </vs-row>
              <vs-row class="mt-4 ml-4" style="font-size:14px">
                <div class="vx-col w-full mt-2 mb-2 flex mr-8">
                  <vs-select
                    autocomplete
                    class="w-full"
                    name="measure"
                    placeholder="Pilih Pemeriksaan"
                    v-model="measure"
                    ref="measure"
                    >
                    <vs-select-item :key="index" :value="item.id" :text="item.measure.name" v-for="(item,index) in listMapping" />
                  </vs-select>
                </div>
              </vs-row>
          </vx-card>
         <vs-card class="mb-base" vs-justify="center">
           <div slot="header">
             <vs-row vs-w="12">
               <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                 <h4>Daftar Lot</h4>
               </vs-col>
               <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="12">
                <vs-spacer></vs-spacer>
                <vs-tooltip text="Tambah">
                  <vs-button radius size="medium" type="border" color="#5d9fc6" icon="add" class="ml-3" @click="openPopup"></vs-button>
                </vs-tooltip>
               </vs-col>
             </vs-row>
           </div>

           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2">
               <vs-table
                   max-items="20"
                   :data="listLot"
                   :class="showFixedHeader?'sticky-header':''"
                   @selected="handleSelected">

                   <template slot="thead">
                       <vs-th class="vs-lg-1">No Lot</vs-th>
                       <vs-th class="vs-lg-2">Nilai Min</vs-th>
                       <vs-th class="vs-lg-3">Nilai Max</vs-th>
                       <vs-th class="vs-lg-2">TV</vs-th>
                       <vs-th class="vs-lg-3">SD Pabrik</vs-th>
                   </template>

                   <template slot-scope="{data}">
                     <tbody :key="indextr" v-for="(tr, indextr) in data">
                       <vs-tr :data="tr" :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':(indextr%2==0?'background: transparent!important;':'')">
                           <vs-td class="vs-lg-1 text-center" style="padding-left: 7px !important; padding-right: 7px !important">
                               No Lot
                           </vs-td>
                           <vs-td class="vs-lg-2 text-center">
                               Nilai Min
                           </vs-td>
                           <vs-td class="vs-lg-3">
                               Nilai Max
                           </vs-td>
                           <vs-td class="vs-lg-2 text-center">
                             TV
                           </vs-td>
                           <vs-td class="vs-lg-2 text-center">
                             SD Pabrik
                           </vs-td>
                       </vs-tr>
                     </tbody>
                   </template>
               </vs-table>
               <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
             </div>
           </div>
         </vs-card>
        </div>
      </div>
      <div class="vx-col w-full" vs-justify="center">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            class="mr-4 mb-4"
            color="danger"
            @click="$router.go(-1)"
            >
            Batal
          </vs-button>
          <vs-button
            class="mr-4 mb-4"
            icon-pack="feather"
            color="#6488e4"
            @click="onConfirm"
            >
            Simpan
          </vs-button>
        </vs-row>
  		</div>

      <vs-prompt class="w30"
        title="Form Input Lot"
        @accept="addRow"
        accept-text="Simpan"
        cancel-text="Batal"
        :active.sync="activePrompt">
           <vx-card>
             <div class="vx-col w-full mb-2">
              <vs-row class="mt-2">
                <vs-col>
                  <vs-input label="No Lot" class="w-11/12" v-model="lotNo"/>
                  <span
                      class="text-danger text-sm"
                      v-show="lotNo == '' && validate"
                      >No Lot harus diisi</span>
                </vs-col>
              </vs-row>
              <vs-row class="mt-4 flex">
                <vs-col class="w-5/12">
                <vs-input v-model="minVal" class="w-full" label="Nilai Min"/>
                  <span
                    class="text-danger text-sm"
                    v-show="minVal == '' && validate"
                    >Nilai Min harus diisi</span>
                </vs-col>
                <vs-col class="w-5/12 ml-10">
                <vs-input label="Nilai Max" class="w-full" v-model="maxVal"/>
                  <span
                    class="text-danger text-sm"
                    v-show="maxVal == '' && validate"
                    >Nilai Max harus diisi</span>
                </vs-col>
              </vs-row>
              <vs-row class="mt-4 flex">
                <vs-col class="w-5/12">
                <vs-input v-model="tv" class="w-full" label="TV"/>
                  <span
                    class="text-danger text-sm"
                    v-show="tv == '' && validate"
                    >TV harus diisi</span>
                </vs-col>
                <vs-col class="w-5/12 ml-10">
                <vs-input label="SD Pabrik" class="w-full" v-model="fabricSD"/>
                  <span
                    class="text-danger text-sm"
                    v-show="fabricSD == '' && validate"
                    >SD Pabrik harus diisi</span>
                </vs-col>
              </vs-row>
             </div>
           </vx-card>
      </vs-prompt>

    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import lab from "@/api/lab";
import master from "@/api/master";
import form from "@/api/form";
import tool from "@/tool/form_tool";
import moment from 'moment';

export default {
  components: {
      Datepicker
  },
  data() {
    return {
			model: {},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
      },
      listMapping: [],
      measure: '',
      listLot: [],
      lotNo: '',
      minVal: 0,
      maxVal: 0,
      tv: 0,
      fabricSD: 0,
      idxSelected: null,
      totalItem: 0,
      listMapping1: [],
      listTest: [],
      loading: false,
      test: null,
      idxSelected1: null,
      activePrompt: false,
      listMeasure: [],
      listReagen: [],
      listReagenMeasure: [],
      listGenTarget: [],
      product: '',
      reagenMeasure: '',
      genTarget: '',
      positionNo: 1,
      validate: false,
      page: 1
    };
  },
  methods: {
    async find(pg) {
      this.model["perPage"] = this.perPage;
      this.model["page"] = pg;
      const frm = await master.listInstrument(this.model);
      if (frm.data.status) {
        this.listData = frm.data.data;
        this.totalItem = frm.data.maxPage;
      } else {
        this.listData= {maxPage:0, data: []};
      }
    },
    handleSelected(tr) {
      this.idSelected = tr.id;
    },
    openConfirm(id) {
        this.idxSelected = id;
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert
        });
    },
    openConfirm1(id) {
        this.idxSelected1 = id;
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert1
        });
    },
    acceptAlert() {
      this.listMapping.splice(this.idxSelected, 1);
    },
    acceptAlert1() {
      this.listMapping1.splice(this.idxSelected1, 1);
    },
    addRow() {
      if (this.measure !== '') {
        let measure = this.lodash.find(this.listMeasure, o => {
          return o.id === this.measure;
        });

        let x = {}
        x.measure = measure;

        if (this.product !== '') {
          let product = this.lodash.find(this.listReagen, o => {
            return o.id === this.product;
          });

          x.product = product;
        }

        this.listMapping.push(x);
        this.validate=false;
      } else {
        this.validate=true;
        this.activePrompt=true;
      }
    },
    onConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin untuk menyimpan data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
    },
    saveData() {
      this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
      };

      let md = this.model;
      if (md.def == true) {
        md.def = 1;
      } else {
        md.def = 0;
      }

      let ms = [];
      for (let i = 0; i < this.listMapping.length; i++) {
        let lp = this.listMapping[i];
        let me = { measure: {id : lp.measure.id},
                    product: {id : lp.product.id}};
        ms.push(me);
      }
      md.measures = ms;
      ms = [];
      for (let i = 0; i < this.listMapping1.length; i++) {
        let lp = this.listMapping1[i];
        let me = { product: {id : lp.product.id},
                    reagenMeasure: {id : lp.measure.id},
                    positionNo: lp.positionNo};
        ms.push(me);
      }
      md.reagenMeasures = ms;

			master.saveInstrument(md, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di simpan ",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/pemeriksaan/instrument/list"
						);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		},
    async getListMeasure() {
			const frm = await lab.listMeasure({perPage: 50, page: 1});
      if (frm.data.status) {
        this.listMeasure = frm.data.data;
      }
    },
    async getListReagen() {
			const frm = await master.listReagen({perPage: 50, page: 1});
      if (frm.data.status) {
        this.listReagen = frm.data.data;
      }
    },
    async getListGenTarget() {
			const frm = await master.listReagenMeasure({perPage: 50, page: 1});
      if (frm.data.status) {
        this.listGenTarget = frm.data.data;
      }
    },
		async firstLoad() {
			const frm = await form.getFormInstrument();
			let idx = this.$route.params.id;
			if (idx) {
				const xmodel = await master.getInstrument(idx);
        this.model = xmodel.data.data[0];
        this.listMapping = (this.model.measures==null?[]:this.model.measures);
        this.listMapping1 = (this.model.reagenMeasures==null?[]:this.model.reagenMeasures);
			} else {
				this.model = frm.data.data[0].model;
      }
    },
    clear() {
      this.measure = '';
      this.product = '';
    },
    async searchMeasure(event) {
      if (event.target.value.length > 2) {
          const frms = await lab.listMeasure({keyword: event.target.value});
          this.listMeasure = frms.data.data;
      }
    },
    async openPopup() {
      this.activePrompt=true;
      this.validate=false;
      this.clear();

      await this.getListMeasure();
      await this.getListReagen();
    }
  },
  computed: {
  },
  watch: {
    measure: function(val) {
    }
  },
  mounted() {
  },
  created() {
    this.firstLoad();
  }
};
</script>


<style lang="scss">
.w30 .vs-dialog {
    max-width:30%;
}

.vs-dialog {
    max-height: 90%;
    overflow-y: auto;
}
.vs-dialog-header {
    padding-right: 22px;
    padding-top: 10px;
}
</style>
